import React from "react";
import { useParams } from "react-router-dom";

export const AnchorUser = ({ user_id }) => {
  let { lang } = useParams();
  const { id } = useParams();

  return Number(id) === Number(user_id) ? user_id : <a className="hover:bg-gray-400" href={`/${lang}/search/${user_id}`}>{user_id}</a>;

};
